import type { CollectionSlug } from 'payload';

/**
 * Every collection whose documents a tenant-site route renders as a page, so
 * a Change Request can record which document the Reviewer was looking at
 * (`pageDocument`). A route with no document behind it (search, the case
 * studies index, a 404) records the page address alone.
 *
 * The blog, portfolio and Concern index settings (`blog-index-pages`,
 * `portfolio-index-pages`, `concern-index-pages`) render pages too but are
 * left out: they are per-tenant singletons, which the multi-tenant plugin
 * refuses as a relationship target, and a tenant has only one of each, so the
 * page address already says which document it is.
 *
 * A route that starts rendering a new collection adds it here, or Change
 * Requests sent from its pages lose their document link.
 */
export const CHANGE_REQUEST_DOCUMENT_COLLECTIONS = [
  'pages',
  'markets',
  'blog-posts',
  'blog-post-categories',
  'case-studies',
  'services',
  'service-categories',
  'team-members',
  'products',
  'product-categories',
  'manufacturers',
  'policies',
  'jobs',
  'concerns',
] as const satisfies readonly CollectionSlug[];

export type ChangeRequestDocumentCollection = (typeof CHANGE_REQUEST_DOCUMENT_COLLECTIONS)[number];
